import { Superscript } from '.';
import { markInputRule, markPasteRule } from '@tiptap/core';

// Match text with two carets on either side
// Example: ^^superscript^^
const inputRegex = /(\^{2}([^^]+)\^{2})$/;
const pasteRegex = /(\^{2}([^^]+)\^{2})/g;

export const CustomSuperscript = Superscript.extend({
   addInputRules() {
      return [
         markInputRule({
            find: inputRegex,
            type: this.type,
         }),
      ];
   },

   addPasteRules() {
      return [
         markPasteRule({
            find: pasteRegex,
            type: this.type,
         }),
      ];
   },
});
